var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-template"},[_c('div',{staticClass:"menu-aux"}),_c('div',{staticClass:"menu-debits"},[_c('menu-debits')],1),_c('div',{staticClass:"page-debit"},[_c('router-view')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }